import { INIT_STATE, SET_FILTER, SET_OPTION } from "../actions/overview";

const defaultState = {};

export function OverviewState(state = defaultState, action) {
    // (de)serialization only happens when entering state (here) and retrieving the state (Overview component)
    const stateIdentifier = JSON.stringify(action.stateIdentifier);

    // we always want to work on our state only
    let overviewState = {
        ...state[stateIdentifier]
    };

    switch (action.type) {
        case INIT_STATE:
            overviewState = action.initialState;
            break;
        case SET_OPTION:
            overviewState = Object.assign({}, overviewState, action.data);
            break;
        case SET_FILTER:
            overviewState = {
                ...overviewState,
                filter: {
                    ...overviewState?.filter,
                    [action.data.columnIdentifier]: action.data.value
                }
            };
            break;
        default:
            return state;
    }

    // reintegrate our state in the global state
    return {
        ...state,
        [stateIdentifier]: overviewState
    };
}
